import React from "react";
import styled from "styled-components";
import { LifeAtBodyPrimary } from "@common/LifeAtText/LifeAtText";
import LoadingSpinner from "@common/LoadingSpinner/LoadingSpinner";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px;
    gap: 20px;
`;

const MIGRATION_INFO_LABEL = "Hang tight, we're getting your new task list ready!";

function TaskListMigrationIndicator() {
    return (
        <Container>
            <LifeAtBodyPrimary>{MIGRATION_INFO_LABEL}</LifeAtBodyPrimary>
            <LoadingSpinner size={40} />
        </Container>
    );
}

export default TaskListMigrationIndicator;
